// eslint-disable-next-line
import React, {Component} from 'react';
import Translator from "../../helpers/Translator";
import {DOMAIN} from "../FilterContainer";

export default class BaseFilterComponent extends Component {
    // eslint-disable-next-line
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        this.translator = new Translator(this.props.translator, DOMAIN);
    }

    componentDidMount() {
        this.props.registerAppliedFilter(this.filter, this.translator.trans(this.name), this.props.clearFilter, this.urlEnabled);
    }

    isApplied() {
        if (this.props.appliedFilters.groups[this.filter] !== undefined) {
            return this.props.appliedFilters.groups[this.filter].enabled;
        }

        return false;
    }

    clearFilter() {
        this.props.clearFilter(this.filter);
    }

    renderClearFilterButton() {
        if (!this.isApplied()) {
            return null;
        }

        return <button onClick={this.clearFilter.bind(this)} className="btn btn-link reset-filter" data-toggle="tooltip" data-placement="top" title={this.translator.trans('Reset')}>×</button>;
    }
}



// WEBPACK FOOTER //
// ./src/components/filters/BaseFilterComponent.js